export enum PreservedViewsTypes {
	LOGS = 'logs',
	TRACES = 'traces',
	METRICS = 'metrics',
	METER = 'meter',
}
